import { apiClient, ApiName } from '@shared/services/api'

export const fetchPosOperations = (config) => {
  return apiClient.get(ApiName.ADMINS, 'operations/pos?status=OPEN', config)
}

export const fetchPosOperation = (id) => {
  return apiClient.get(ApiName.ADMINS, `operations/pos/${id}`)
}

export const deletePosOperation = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'super/operations/pos', id)
}

export const createPosOperation = (data) => {
  return apiClient.post(ApiName.ADMINS, 'operations/pos', data)
}

export const updatePosOperation = (data) => {
  return apiClient.put(ApiName.ADMINS, 'operations/pos', data)
}

export const uploadDocumentPos = (id, formData, onProgress) => {
  return apiClient.post(
    ApiName.ADMINS,
    `operations/pos/${id}/docs`,
    formData,
    {
      'Content-Type': 'multipart/form-data'
    },
    { onUploadProgress: onProgress }
  )
}

export const fetchOperationTaxes = (id, clientId, liquidationFC = '') => {
  return apiClient.get(
    ApiName.ADMINS,
    `operations/pos/fees?ids=${id}&clientId=${clientId}&liquidationType=${liquidationFC}`
  )
}

export const createPosOperationHomeBroker = (body) => {
  return apiClient.post(ApiName.ADMINS, 'operations/pos/homeBroker', body)
}

export const createPosDocsSignature = (data, posId) => {
  return apiClient.post(ApiName.ADMINS, `operations/pos/${posId}/docs/docusign/contracts`, data)
}

export const notifyPayment = (posId, data) => {
  return apiClient.post(
    ApiName.ADMINS,
    `operations/pos/${posId}/notifications/pendingPayment`,
    data
  )
}

export const downloadInvoice = (posOperationId) => {
  return apiClient.get(ApiName.TPAY, `operations/pos/${posOperationId}/invoice`)
}

export const downloadAcan = (posOperationId, config = {}) => {
  return apiClient.apiClient.get(`/tpay/operations/pos/${posOperationId}/acan22`, config)
}

export const fetchTransferClientBank = (brokerId) => {
  return apiClient.get(ApiName.ADMINS, `financialInstitutions/${brokerId}`)
}

export const signCloudArchive = (data) => {
  return apiClient.post(ApiName.ARCHIVES, '', data)
}
